import { createTheme, type MantineTheme, TagsInput } from '@mantine/core';
import type { PartialDeep } from 'type-fest';

import { inputStyles, themedMantineInput } from './Input';

export const ThemedMantineTagsInput: PartialDeep<MantineTheme> = createTheme({
  components: {
    TagsInput: TagsInput.extend({
      styles: (theme, params) => {
        if (params.variant === 'unstyled') return {};

        return themedMantineInput(theme);
      },
      classNames: (theme, params) => {
        if (params.variant === 'unstyled') return {};

        return { input: inputStyles.input(theme) };
      },
    }),
  },
});
